<template>
  <v-app class="Email">
    <v-main align="center" justify="center">
      <br />
      <!-- VERIFIED -->
      <div class="verified" v-if="verified">
        <v-img
          class="centerImg"
          src="@/assets/successIcon.png"
          width="200"
          height="200"
        ></v-img>
        <br />
        <v-card
          class="mx-auto"
          max-width="344"
          color="rgba(255, 255, 255, 0.1)"
          outlined
        >
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title
                class="headline mb-1 text-h3 font-weight-medium"
                >Email verified</v-list-item-title
              >
              <v-list-item-subtitle class="text-h6">
                Thank you. Your email address was successfully verified.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </div>
      <!-- ALREADY VERIFIED -->
      <div class="alreadyVerified" v-if="alreadyVerified">
        <v-img
          class="centerImg"
          src="@/assets/infoIcon.png"
          width="200"
          height="200"
        ></v-img>
        <br />
        <v-card
          class="mx-auto"
          max-width="500"
          color="rgba(255, 255, 255, 0.1)"
          outlined
        >
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title
                class="headline mb-1 text-h3 font-weight-medium"
                >Already verified</v-list-item-title
              >
              <v-list-item-subtitle class="text-h6">
                Your email address was already verified.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </div>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "Email",
  data() {
    return {
      verified: false,
      alreadyVerified: false,
      token: this.$route.params.token
    };
  },
  async created() {
    await this.$shttp
      .post("confirm-email/" + this.token)
      .then(() => (this.verified = true))
      .catch((error) => {
        if (error.response.data.errors.StatusCode == 4112)
          this.alreadyVerified = true;
        else this.$router.push("/not-found");
      });
  },
  mounted() {},
  components: {}
};
</script>
<style scoped>
.centerImg {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
</style>
